import { useRef, useEffect } from 'react'

const DocumentTitle = (title) =>{

  useEffect(() => {
    document.title = title;
  });
}
export default DocumentTitle